export default __webpack_public_path__ + "static/media/particles-mbl.5425fbd9.svg";